// extracted by mini-css-extract-plugin
module.exports = {"container":"district_container__3IXwj"};